import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { PageHeader } from '@cmi/addin-core';
import { map } from 'rxjs';

@Component({
  selector: 'cmi-root',
  imports: [RouterOutlet, PageHeader],
  templateUrl: './app.html',
  host: { class: 'flex flex-col h-screen' }
})
export class App {
  private readonly _router = inject(Router);
  private readonly _route = inject(ActivatedRoute);

  protected readonly hideShell = toSignal(
    this._router.events.pipe(
      map(() => (this._route.firstChild?.snapshot.data['hideShell'] as boolean) ?? false)
    ),
    { initialValue: false }
  );
}
